import { scopedTranslation } from '@frontend/utils/I18n'

import { UnassignShiftSlotDocument } from '@frontend/graphql/mutations/unassignShiftSlot.generated'

import { useRosterActionMutation } from '../roster_board/useRosterActionMutation'

import type { ShiftSlotWithShift } from '../shifts/types'

type UnassignShiftValues = {
  id: ShiftSlotWithShift['id']
  onSuccess: () => void
  onError?: () => void
}

const t = scopedTranslation('components.unassign_shift')

const useUnassignShiftSlotMutation = () => {
  const { run, isPending } = useRosterActionMutation({
    document: UnassignShiftSlotDocument,
    succeeded: (response) => Boolean(response?.unassignShiftSlot?.shiftSlot?.id),
    errorCode: 'UNASSIGN_SHIFT_ERROR',
    failureMessage: t('errors.unable_to_unassign_shift_error'),
    extractErrors: (response) => response?.unassignShiftSlot?.errors,
  })

  return {
    unassignShiftSlot: ({ id, onSuccess, onError }: UnassignShiftValues) => run({ id, onSuccess, onError }),
    isPending,
  }
}

export default useUnassignShiftSlotMutation
